<template>
  <section>
    <div class="container">
      <h2>
        Місія<br />
        Drone Force
      </h2>
      <div class="content">
        <p>{{ description }}</p>
        <div class="video-container">
          <div v-if="!isVideoPlaying" class="flex-video-block">
            <img
              class="btn"
              src="@/assets/video/play-btn.png"
              alt="Video poster"
              @click="playVideo"
            />
            <img
              class="video"
              src="@/assets/video/video-bg.png"
              alt="Video poster"
              @click="playVideo"
            />
          </div>
          <video
            ref="videoPlayer"
            class="video"
            src="@/assets/video/video2.mp4"
            controls
            @play="onVideoPlay"
            v-show="isVideoPlaying"
          ></video>
        </div>
      </div>
    </div>
  </section>
</template>

<script>
export default {
  name: "df-mission",
  data() {
    return {
      isVideoPlaying: false,
      title: `Місія Drone Force`,
      description:
        "Формуємо технологічне військо, що наближає нашу Перемогу сьогодні " +
        "та створює перспективу розвитку в майбутньому завдяки інноваційним " +
        "технологіям і екосистемі долучення вмотивованих громадян",
    };
  },
  methods: {
    playVideo() {
      const video = this.$refs.videoPlayer;
      if (video) {
        video.play();
        this.isVideoPlaying = true;
      }
    },
    onVideoPlay() {
      this.isVideoPlaying = true;
    },
  },
};
</script>

<style lang="scss" scoped>
.content {
  display: flex;
  flex-direction: column;
  gap: 24px;
  p {
    max-width: 870px;
    font-family: UAF Sans;
    font-weight: 400;
    font-size: 24px;
    line-height: 34px;

    @media (max-width: 767px) {
      font-size: 18px;
      line-height: 20px;
    }
  }

  .video {
    width: 100%;
  }
}

h2 {
  font-family: "UAF Sans H", serif;
  font-weight: 700;
  font-size: 32px;
  line-height: 36px;
  text-transform: uppercase;
  max-width: 390px;
  margin-bottom: 44px;

  @media (max-width: 767px) {
    margin-bottom: 10px;
  }
}

.flex-video-block {
  position: relative;

  .btn {
    position: absolute;
    max-width: 100px;
    top: calc(50% - 67px);
    left: calc(50% - 50px);

    @media (max-width: 767px) {
      max-width: 60px;
      top: calc(50% - 35px);
      left: calc(50% - 30px);
    }
  }
}
</style>
